/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmPromptsGetVersion } from "../../funcs/llmPromptsGetVersion.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetPromptVersionRequest$inboundSchema,
};

export const tool$llmPromptsGetVersion: ToolDefinition<typeof args> = {
  name: "llm-prompts-get-version",
  description: `Get a specific version

Retrieves a specific version of a prompt by version number.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmPromptsGetVersion(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
